import { render, staticRenderFns } from "./stoffe.vue?vue&type=template&id=09683068&"
import script from "./stoffe.vue?vue&type=script&lang=js&"
export * from "./stoffe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports